export default "__VITE_ASSET__DmLiCAUr__"